import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { HeadMeta } from '@packages/shared';
import { SchemaOrg } from '../SchemaOrg';

const ProductHeadFragment = graphql(/* GraphQL */ `
  fragment ProductSeo on Product {
    name
    productHeadSeo: seo(locale: $locale) {
      title
      description
      canonicalUrl
      keywords
      robots
    }
    ...SchemaOrgFragment
  }
`);

interface ProductPageHeadProps {
  data: FragmentType<typeof ProductHeadFragment>;
}

export const ProductPageHead = ({ data }: ProductPageHeadProps) => {
  const product = getFragmentData(ProductHeadFragment, data);
  const { name, productHeadSeo } = product;

  return (
    <HeadMeta
      meta={{
        title:
          productHeadSeo && productHeadSeo.title
            ? productHeadSeo.title.replace('{ProductName}', name)
            : undefined,
        robots: productHeadSeo?.robots ?? undefined,
        keywords: productHeadSeo?.keywords ?? undefined,
        description:
          productHeadSeo && productHeadSeo.description
            ? productHeadSeo.description.replace('{ProductName}', name).replace(/"/g, '&quot;')
            : undefined,
      }}
      links={{
        canonical: productHeadSeo?.canonicalUrl ?? undefined,
      }}
      schemaorg={SchemaOrg({ productData: product })}
    />
  );
};
